export default __webpack_public_path__ + "static/media/XEMP-7.367908a5.jpg";